import React from 'react'
interface Props {
  styleCssImage: string
}

const logorechargePrapayee: React.FC<Props> = ({ styleCssImage }) => {
  return (
    <svg
    className={`${styleCssImage} fill-[#FF6C47]`}
     width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="60" height="60.0004" rx="10" 
      // fill="#FF6C47" 
      />
      <path
        d="M45 26.2498C44.9453 22.8713 44.6838 20.9196 43.4346 19.5191C43.1818 19.2358 42.9033 18.9738 42.6021 18.7361C40.7191 17.2498 37.8988 17.2498 32.2584 17.2498H27.7561C22.1156 17.2498 19.2953 17.2498 17.4123 18.7361C17.1112 18.9738 16.8327 19.2358 16.58 19.5191C15 21.2904 15 23.9435 15 29.2498C15 34.556 15 37.2091 16.58 38.9804C16.8327 39.2638 17.1112 39.5257 17.4123 39.7634C19.2953 41.2498 22.1156 41.2498 27.7561 41.2498H28.5"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M15 24.7498H45" stroke="white" strokeWidth="2" strokeLinejoin="round" />
      <path
        d="M40.9999 30.7498L42.2347 31.8866C42.5035 32.1508 42.638 32.2829 42.5907 32.3951C42.5433 32.5073 42.3532 32.5073 41.9731 32.5073H37.3166C34.9326 32.5073 33 34.4068 33 36.7498C33 37.2779 33.0983 37.7834 33.2775 38.2498M37.0001 42.7498L35.7653 41.6129C35.4965 41.3488 35.3621 41.2166 35.4093 41.1044C35.4567 40.9922 35.6468 40.9922 36.0269 40.9922H40.6834C43.0674 40.9922 45 39.0928 45 36.7498C45 36.2216 44.9018 35.7161 44.7225 35.2498"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default logorechargePrapayee
